/**
 * @constructor
 * @implements {Foundation.Login.ThirdPartyAuthenticator}
 */
Foundation.Facebook.Authenticator = function () {
  /**
   * @private
   * @type {Foundation.Promise}
   */
  this._fdnMember = null

  /**
   * @private
   * @type {Foundation.Facebook.User}
   */
  this._fbUser = null
}

/**
 * @const {string}
 * @private
 */
Foundation.Facebook.Authenticator._notLoggedInErrorMessage = "User does not appear to be logged in to Facebook and connected to publication account."

Foundation.Facebook.Authenticator.prototype.sessionManagerDelegateID = function () {
  return "facebook"
}

Foundation.Facebook.Authenticator.prototype.serviceName = function () {
  return "Facebook"
}

Foundation.Facebook.Authenticator.prototype.authenticateWithThirdPartyService = function () {
  var result = new Foundation.Promise()
  var fbApp = Foundation.Facebook.Application.sharedInstance()

  // window.console.log('Foundation.Facebook.Authenticator.authenticateWithThirdPartyService')

  fbApp.isAuthenticated().then(function () {
    // Facebook already logged in for this site
    // window.console.log('Facebook already logged in for this site')
    var fbUser = this._authenticatedFacebookUser()
    fbUser.then(function () {
      result.fulfill()
    }.bind(this), function () {
      result.failWith(fbUser)
    }.bind(this))
  }.bind(this), function () {
    // Facebook not logged in for this site
    // window.console.log('Facebook not logged in for this site')
    fbApp.logIn("email").then(function () {
      var fbUser = this._authenticatedFacebookUser()
      fbUser.then(function () {
        result.fulfill()
      }.bind(this), function () {
        result.failWith(fbUser)
      }.bind(this))
    }.bind(this), function () {
      result.fail()
    }.bind(this))
  }.bind(this))

  return result
}

Foundation.Facebook.Authenticator.prototype.sessionTTL = function () {
  return 0
}

Foundation.Facebook.Authenticator.prototype.suggestedUserEmailAddress = function () {
  return /** @type {string} */ (this._authenticatedFacebookUser().get("email")) || null
}

Foundation.Facebook.Authenticator.prototype.suggestedUserName = function () {
  return /** @type {string} */ (this._authenticatedFacebookUser().get("name")) || null
}
Foundation.Facebook.Authenticator.prototype.suggestedUserFullName = function () {
  return /** @type {string} */ (this._authenticatedFacebookUser().get("name")) || null
}

Foundation.Facebook.Authenticator.prototype.authenticateWithFoundation = function () {
  var result = new Foundation.Promise()
  var fbApp = Foundation.Facebook.Application.sharedInstance()
  // window.console.log('Foundation.Facebook.Authenticator.authenticateWithFoundation')
  fbApp.isAuthenticated().then(function () {
    // Facebook already logged in for this site
    // window.console.log('Foundation.Facebook.Authenticator.authenticateWithFoundation .isAuthenticated() THEN')
    var fbUser = this._authenticatedFacebookUser()
    fbUser.then(function () {
      // Retrieved Facebook user info
      // window.console.log('Foundation.Facebook.Authenticator.authenticateWithFoundation ._authenticatedFacebookUser() THEN')
      this._fdnMember = new Foundation.API("GET", "Facebook/Member", {
        "facebookId": fbUser.get("id"),
        "email": fbUser.get("email") || undefined
      })
      this._fdnMember.then(function () {
        // window.console.log('Foundation.Facebook.Authenticator.authenticateWithFoundation ._fdnMember THEN')
        // Foundation.API success response
        if (this._fdnMember.get("isLikelyToCollide")) {
          // Foundation Member not authenticated but Facebook User might already exist
          return result.fail()
        }
        else {
          // Foundation Member authenticated
          result.marry(this._fdnMember)
        }
      }.bind(this), function () {
        // Foundation.API error response
        // window.console.log('Foundation.Facebook.Authenticator.authenticateWithFoundation ._fdnMember FAIL')
        result.marry(this._fdnMember)
      }.bind(this))
    }.bind(this), function () {
      // Failed to get Facebook user info
      result.failWith(fbUser)
    }.bind(this))
  }.bind(this), function () {
    // Facebook not logged in for this site
    // window.console.log('Facebook not logged in for this site')
    result.failWith({"errors": [Foundation.Facebook.Authenticator._notLoggedInErrorMessage]})
  }.bind(this))

  return result
}

Foundation.Facebook.Authenticator.prototype.decorateMember = function (/* member */) {
  var done = new Foundation.Promise()
  done.fulfill()  // Nothing to do here
  return done
}

Foundation.Facebook.Authenticator.prototype.memberOid = function () {
  return /** @type {number} */ (this._fdnMember.get("oid"))
}

Foundation.Facebook.Authenticator.prototype.memberUserName = function () {
  return /** @type {string} */ (this._fdnMember.get("userName"))
}

Foundation.Facebook.Authenticator.prototype.memberAvatarUrl = function () {
  return /** @type {string} */ (this._fdnMember.get("avatarUrl"))
}

Foundation.Facebook.Authenticator.prototype.accountIsLikelyToCollide = function () {
  return /** @type {boolean} */ (this._fdnMember.get("isLikelyToCollide")) || false
}


Foundation.Facebook.Authenticator.prototype.linkLoggedInMemberWithThirdPartyCredentials = function () {
  var result = new Foundation.Promise()
  var fbApp = Foundation.Facebook.Application.sharedInstance()

  fbApp.isAuthenticated().then(function () {
    var fbUser = this._authenticatedFacebookUser()
    fbUser.then(function () {
      this._fdnMember = new Foundation.API("POST", "Facebook/Member", {
        "facebookId": fbUser.get("id")
      })
    }.bind(this), function () {
      result.failWith(fbUser)
    }.bind(this))
  }.bind(this), function () {
    result.failWith({"errors": [Foundation.Facebook.Authenticator._notLoggedInErrorMessage]})
  }.bind(this))

  return result
}

Foundation.Facebook.Authenticator.prototype.userCanceledAccountCreation = function () {
  return Foundation.Facebook.Application.sharedInstance().uninstall()
}

Foundation.Facebook.Authenticator.prototype._authenticatedFacebookUser = function () {
  if (!this._fbUser) {
    this._fbUser = new Foundation.Facebook.User("me")
  }
  return this._fbUser
}
